/* Vidéos chargées à l'approche de l'écran (une seule vidéo chargée à l'ouverture : le hero) */
(function(){
  function start(v){ if(!v.dataset.src) return; v.src=v.dataset.src; v.removeAttribute('data-src'); v.load(); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
  function init(){
    var vids=[].slice.call(document.querySelectorAll('video[data-src]'));
    if(!('IntersectionObserver' in window)){ vids.forEach(start); return; }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target;
      if(e.isIntersecting){ if(v.dataset.src) start(v); else { var p=v.play(); if(p&&p.catch)p.catch(function(){}); } }
      else if(!v.paused){ v.pause(); } }); },{rootMargin:'250px 0px'});
    vids.forEach(function(v){ io.observe(v); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
